import { createApp } from 'vue';

import { storePinia } from '@/storePinia';
import { lazyBackground } from '@/directives/lazyBackground';
import { IComponents, IComponent } from './IVue';

class Vue {
  components: IComponents;

  constructor() {
    this.components = {};
  }

  /** Добавление комопнента Vue для работы с ним на странице */
  setComponent(vueComponent: IComponent) {
    try {
      if (vueComponent) {
        // eslint-disable-next-line no-underscore-dangle
        const fileName = vueComponent?.__file?.match(/[a-zA-Z]+\.vue$/)?.[0];
        // eslint-disable-next-line no-underscore-dangle
        const componentName = vueComponent?.name ?? vueComponent?.__name ?? fileName?.slice(0, -4);

        if (!vueComponent?.name && componentName) {
          this.components[componentName] = {
            ...vueComponent,
            name: componentName,
          };
        } else if (componentName) {
          this.components[componentName] = vueComponent;
        } else {
          // eslint-disable-next-line no-underscore-dangle
          throw new Error(`try set vue component Error`);
        }
      } else {
        throw new Error(`SetComponent is empty ${vueComponent}`);
      }
    } catch (err) {
      console.error(err, vueComponent);
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  createPropsFromAttributes = (dom: HTMLDivElement) => {
    try {
      const { dataset } = dom;
      const params: { [key: string]: string } = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const key in dataset) {
        // eslint-disable-next-line no-continue
        if (key === 'vue' || !dataset[key]) continue;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        params[key] = JSON.parse(dataset[key]);
      }

      return params;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  async createComponent(el: HTMLDivElement) {
    const componentName = el.dataset.vue;
    el.classList.add('init');

    if (componentName && componentName in this.components) {
      const component = this.components[componentName];

      const app = createApp(
        {
          ...component,
        },
        this.createPropsFromAttributes(el)
      );

      if (process.env.NODE_ENV !== 'production') {
        app.config.performance = true;
      }

      app.use(storePinia);

      if (componentName === 'Cabinet') {
        const { default: router } = await import(
          /* webpackChunkName: "cabinet-router" */
          '../routs/router'
        );

        app.use(router);

        await router.isReady();
      }

      app.directive('lazy-bg', lazyBackground);

      app.mount(el);
    } else {
      console.error(`component: ${componentName} is undefined`);
    }
  }

  init() {
    try {
      const items = document.querySelectorAll('[data-vue]:not(.init)');

      items.forEach((el) => {
        this.createComponent(el as HTMLDivElement);
      });
    } catch (err) {
      console.error(err);
    }
  }
}

export default Vue;
